import { BindingEngine, autoinject, bindable, bindingMode, customElement, observable, factory } from 'aurelia-framework';
import { CheckBoxBaseCustomElement } from 'General/Resources/Elements/CheckBox/CheckBoxBase';

@autoinject
@customElement('check-box-birds')
export class CheckBoxBirds extends CheckBoxBaseCustomElement {
}